<template>
      <div >
        <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
        <br/>
        <span style="color:#909399;font-size: 13px; margin-left: 50px;">{{$t('analyse.accountDataTable.updateTime')}} {{time}}</span>
        <div style="margin: 70px">
          <el-tag  style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:25px">{{realAccount}}</span><p>{{$t('analyse.realTable.realAccount')}}</p></el-tag>
          <el-tag type="success" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:25px">{{realCount}}</span><p>{{$t('analyse.realTable.realCount')}}</p></el-tag>
          <el-tag type="warning" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{realHandCount}}</span><p>{{$t('analyse.realTable.realHandCount')}}</p></el-tag>
          <el-tag type="danger" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{againRealAccount}}</span><p>{{$t('analyse.realTable.againRealAccount')}}</p></el-tag>
          <el-tag  style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:12px">{{againRealHandCount}}</span><p>{{$t('analyse.realTable.againRealHandCount')}}</p></el-tag>
          <el-tag type="success" style="padding: 30px; padding-bottom: 110px; margin-left: 50px; font-size: 20px;"><span style="padding-left:25px">{{dayAvgAccount}}</span><p>{{$t('analyse.realTable.dayAvgAccount')}}</p></el-tag>
        </div>
        <div style=" margin-left: 1130px;">
          <el-button id="dayBut" @click="dayBut"  :type="type==1 ? 'success':'primary'" >{{$t('analyse.accountDataTable.day')}}</el-button>
          <el-button id="weekBut" @click="weekBut" :type="type==2 ? 'success':'primary'" :disabled="weekBy">{{$t('analyse.accountDataTable.weekBy')}}</el-button>
          <el-button id="monthBut" @click="monthBut" :type="type==3 ? 'success':'primary'" :disabled="monthBy">{{$t('analyse.accountDataTable.monthBy')}}</el-button>
        </div>
        <div id="main" style="width:90%; height: 700px"></div>

        <br/>
        <span style="color:#909399;font-size: 15px; font-weight: bold; margin-left: 50px;">{{$t('analyse.accountDataTable.detail')}}</span>
        <el-button type="primary" style="float:right;"  @click="exportData()" v-auth="'analyse:deal:export'">{{$t('analyse.accountDataTable.export')}}</el-button>
        <el-table  :data="tableData" style="width: 100%;margin-left: 70px;"  :default-sort = "{prop: 'date', order: 'descending'}">
          <el-table-column  prop="time"  :label="$t('analyse.accountDataTable.date')"  sortable  />
          <el-table-column  prop="realAccount"  :label="$t('analyse.realTable.realAccount')"  sortable  />
          <el-table-column  prop="realCount"  :label="$t('analyse.realTable.realCount')"  sortable/>
          <el-table-column  prop="realHand"   :label="$t('analyse.realTable.realHandCount')"  sortable/>
          <el-table-column  prop="avgRealCount"  :label="$t('analyse.realTable.againRealAccount')"  sortable/>
          <el-table-column  prop="avgRealHand"  :label="$t('analyse.realTable.againRealHandCount')"  sortable/>
        </el-table>
      </div>

</template>

<script>
  //交易平台
  let platforms={};
  //产品类型
  let productTypes={};
  //产品
  let products=[];
    //table封装组件
    import URL from '@/views/analyse/util/url'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    import echarts from 'echarts'
    export default {
        components: {
            FORM,UPDATE
        },
        data() {
            return {
                // drawLineOption:{},
                tableData:{},
                cakeOption:{},
                time:'',
                type:1,
                realAccount:0,
                realCount:0,
                realHandCount:"",
                againRealAccount:"",
                againRealHandCount:"",
                dayAvgAccount:"",
                weekBy:true,
                monthBy:true,
                formData:{
                    cols:[
                        { title: window.$t("analyse.realTable.time"), field: 'time',type:6,change:(data,col)=>{
                                if(data.time!=null){
                                    let startTime=data.timeStart;
                                    let endTime=data.timeEnd;
                                    let day=(endTime-startTime)/(24*60*60*1000);
                                    if(day>7){
                                        this.weekBy=false;
                                    }else{
                                        this.weekBy=true;
                                    }
                                    if(this.getMonthCount(startTime,endTime)>=1){
                                        this.monthBy=false;
                                    }else{
                                        this.monthBy=true;
                                    }
                                }

                            }},
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'platform',type:2,optionList:this.platforms},
                        { title: window.$t("analyse.realTable.productType"), field: 'productType',type:2,optionList:this.productTypes},
                        { title: window.$t("analyse.realTable.tradeConfig"), field: 'product',type:2,data:[]},
                        {click:window.$t("common.search"),auth:'analyse:deal:sel'}
                    ]
                },

            }
        },
        mounted(){
            this.$axios.get(URL.realVn.getData).then(res => {
                if (res.code == 0) {
                    this.platforms=res.result.platforms;
                    this.productTypes=res.result.productTypes;
                    this.products=res.result.product;
                    this.formData.cols =[
                        { title: window.$t("analyse.realTable.time"), field: 'time',type:6,change:(data,col)=>{
                                if(data.time!=null){
                                    let startTime=data.timeStart;
                                    let endTime=data.timeEnd;
                                    let day=(endTime-startTime)/(24*60*60*1000);
                                    if(day>7){
                                        this.weekBy=false;
                                    }else{
                                        this.weekBy=true;
                                    }
                                    if(this.getMonthCount(startTime,endTime)>=1){
                                        this.monthBy=false;
                                    }else{
                                        this.monthBy=true;
                                    }
                                }

                            }},
                        { title: window.$t("analyse.depositTable.inChannel"), field: 'platform',type:2,optionList:this.platforms},
                        { title: window.$t("analyse.realTable.productType"), field: 'productType',type:2,optionList:this.productTypes},
                        { title: window.$t("analyse.realTable.tradeConfig"), field: 'product',type:2,data:[],optionListArrRender:(model,col)=>{
                            let productType=model.productType;
                            if(productType!=undefined && productType !=null){
                                for(let i of this.products){
                                    for(let key in i){
                                        if(productType == key){
                                        return i[key];
                                        }
                                    }
                                }
                            }
                            return [];
                    }},
                        {click:window.$t("common.search"),auth:'analyse:deal:sel'}
                    ];
                }
            });
        },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            dayBut(){
                this.type=1;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.platform=this.formData.cols[1].data;
                data.productType=this.formData.cols[2].data;
                data.product=this.formData.cols[3].data;
                this.getDeal(1,data);
            },
            weekBut(){
                this.type=2;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.platform=this.formData.cols[1].data;
                data.productType=this.formData.cols[2].data;
                data.product=this.formData.cols[3].data;
                this.getDeal(2,data);
            },
            monthBut(){
                this.type=3;
                let data={};
                data.timeStart=null;
                data.timeEnd=null;
                if(this.formData.cols[0].data!=undefined){
                    data.timeStart=this.formData.cols[0].data[0];
                    data.timeEnd=this.formData.cols[0].data[1];
                }
                data.platform=this.formData.cols[1].data;
                data.productType=this.formData.cols[2].data;
                data.product=this.formData.cols[3].data;
                this.getDeal(3,data);
            },
            exportData(){
                let startTime=null;
                let endTime=null;
                if(this.formData.cols[0].data!=undefined){
                  startTime=this.formData.cols[0].data[0];
                  endTime=this.formData.cols[0].data[1];
                }
                let platform=this.formData.cols[1].data;
                let productType=this.formData.cols[2].data;
                let product=this.formData.cols[3].data;
                if((startTime!=undefined && endTime!=undefined) ||platform!=undefined ||productType!=undefined ||product!=undefined ) {
                    if (platform == undefined)
                        platform = "";
                    if (productType == undefined)
                        productType = "";
                    if (product == undefined)
                        product = "";
                    if (startTime == undefined)
                        startTime = null;
                    if (endTime == undefined)
                        endTime = null;
                    let urlLast = "";
                    if (startTime != null && endTime != null) {
                        urlLast = "&startTime=" + startTime + "&endTime=" + endTime;
                        download.exportExcel(URL.realVn.dealExport + "?platform=" + platform+"&productType="+productType+"&tradeConfig="+product+urlLast, {}, "交易分析信息");
                    } else {
                        download.exportExcel(URL.realVn.dealExport, {}, "交易分析信息");
                    }
                }else {
                    download.exportExcel(URL.realVn.dealExport, {}, "交易分析信息");
                }
            },
            //折线图
            drawLine(id,drawLineOption) {
                this.charts = echarts.init(document.getElementById(id));
                // console.log(JSON.stringify(drawLineOption));
                // 指定图表的配置项和数据
                // var option = {
                //     tooltip: {              //设置tip提示
                //         trigger: 'axis'
                //     },
                //     legend: {               //设置区分（哪条线属于什么）
                //         data: ['real', 'demo', 'activity']
                //     },
                //     color: ['#96CDCD', '#8AE09F', '#FA6F53'],       //设置区分（每条线是什么颜色，和 legend 一一对应）
                //     xAxis: {                //设置x轴
                //
                //         type: 'category',
                //         boundaryGap: false,     //坐标轴两边不留白
                //         data: ['2019-1-1', '2019-2-1', '2019-3-1', '2019-4-1', '2019-5-1', '2019-6-1', '2019-7-1',],
                //         // nameTextStyle: {        //坐标轴名称的文字样式
                //         //     color: '#FA6F53',
                //         //     fontSize: 16,
                //         //     padding: [0, 0, 0, 20]
                //         // }
                //         // axisLine: {             //坐标轴轴线相关设置。
                //         //     lineStyle: {
                //         //         color: '#FA6F53',
                //         //     }
                //         // }
                //     },
                //     yAxis: {
                //         name: '近7日用户增长趋势',
                //         nameTextStyle: {
                //             // color: '#FA6F53',
                //             fontSize: 13,
                //             padding: [0, 0, 10, 0]
                //         },
                //
                //         type: 'value'
                //     },
                //     series: [
                //         {
                //             name: 'real',
                //             data: [420, 200, 150, 20, 70, 110, 130],
                //             type: 'line',
                //             lineStyle: {
                //                 normal: {
                //                     color: '#96CDCD',
                //                 }
                //             },
                //         }, {
                //             name: 'demo',
                //             data: [220, 232, 201, 234, 290, 230, 220],
                //             type: 'line',               // 类型为折线图
                //             lineStyle: {                // 线条样式 => 必须使用normal属性
                //                 normal: {
                //                     color: '#8AE09F',
                //                 }
                //             },
                //         },
                //         {
                //             name: 'activity',
                //             data: [120, 200, 150, 80, 70, 110, 130],
                //             type: 'line',
                //             lineStyle: {
                //                 normal: {
                //                     color: '#FA6F53',
                //                 }
                //             },
                //         }
                //     ]
                // };
                this.charts.setOption(drawLineOption);
            }, /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(clickName == "查询" || window.$t("common.search") == clickName){
                    this.getDeal(1,data);
                }
            },
            getDeal(type,data){
                if((data.timeStart!=undefined && data.timeEnd!=undefined)||data.platform!=undefined || data.product !=undefined|| data.productType !=undefined) {
                    if (data.platform == undefined)
                        data.platform = "";
                    if (data.product == undefined)
                        data.product = "";
                    if (data.productType == undefined)
                        data.productType = "";
                    if(data.timeStart==undefined)
                        data.timeStart=null;
                    if(data.timeEnd==undefined)
                        data.timeEnd=null;
                    let urlLast="";
                    if(data.timeStart!=null && data.timeEnd !=null){
                        urlLast="&startTime=" + data.timeStart + "&endTime=" +  data.timeEnd;
                    }
                    this.$axios.get(URL.realVn.deal + "?platform=" + data.platform+"&tradeConfig="+data.product+"&productType="+data.productType +"&type="+type+urlLast).then(res => {
                        if (res.code == 0) {
                            let brokenLine=res.result.brokenLine;
                            this.time=res.result.time;
                            this.realAccount=res.result.realAccount;
                            this.realCount=res.result.realCount;
                            this.realHandCount=res.result.realHandCount;
                            this.againRealAccount=res.result.againRealAccount;
                            this.againRealHandCount=res.result.againRealHandCount;
                            this.dayAvgAccount=res.result.dayAvgAccount;
                            this.tableData=res.result.details;
                            this.$nextTick(function() {
                                this.drawLine('main',brokenLine);
                            });
                        }
                    });
                }else{
                    this.$axios.get(URL.realVn.deal+"?type="+type).then(res => {
                        if (res.code == 0) {
                            let brokenLine=res.result.brokenLine;
                            this.time=res.result.time;
                            this.realAccount=res.result.realAccount;
                            this.realCount=res.result.realCount;
                            this.realHandCount=res.result.realHandCount;
                            this.againRealAccount=res.result.againRealAccount;
                            this.againRealHandCount=res.result.againRealHandCount;
                            this.dayAvgAccount=res.result.dayAvgAccount;
                            this.tableData=res.result.details;
                            this.$nextTick(function() {
                                this.drawLine('main',brokenLine);
                            });
                        }
                    });
                }
            },
            getMonthCount(startTime,endTime){
                let date2=this.fromDate(startTime);
                let date1=this.fromDate(endTime);
                date1 = date1.split('-');
                // 得到4102月数1653
                date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
                // 拆分年月日
                date2 = date2.split('-');
                // 得到月数
                date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
                return Math.abs(date1 - date2);
            },fromDate(date){
                date = new Date(date);
                let YY = date.getFullYear() + '-';
                let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                return YY + MM + DD;
            }

        }
    }
</script>
